import WordsStats from './WordsStats';

export default WordsStats;
